import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    width: '100%',
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  /** Status filter: left side of toolbar row */
  filter: {
    width: 120,
    minWidth: 120,
  },
  /** Chronological toggle: right side of toolbar row */
  sortToggle: {
    marginLeft: 'auto',
  },
  toolbarRow: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
  },
  empty: {
    marginTop: theme.spacing(5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));
